import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalVariant } from '@patternfly/react-core';

type DeleteSkillsPathModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
};

const DeleteSkillsPathModal = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteSkillsPathModalProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    if (!isDeleting) onClose();
  };

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Modal
      variant={ModalVariant.small}
      title={t('Delete skills path')}
      isOpen={isOpen}
      onClose={handleClose}
      actions={[
        <Button
          key="confirm"
          variant="danger"
          onClick={handleConfirm}
          isLoading={isDeleting}
          isDisabled={isDeleting}
        >
          {isDeleting ? t('Deleting') : t('Delete')}
        </Button>,
        <Button
          key="cancel"
          variant="link"
          onClick={handleClose}
          isDisabled={isDeleting}
        >
          {t('Cancel')}
        </Button>,
      ]}
    >
      {t(
        'You are about to delete your custom skills path. This will remove it from your catalog, as well as all users that have been assigned to it. Would you like to continue?',
      )}
    </Modal>
  );
};

export default DeleteSkillsPathModal;
